export const CHARGEBACKS_ROUTE_PATHS = {
  chargebacks: '/fraud/chargebacks',
};
